// Code values the offline UI uses (date format options, review option
// codes, Tailwind classes): never text a user reads.
export const DATE_MEDIUM: Intl.DateTimeFormatOptions = { dateStyle: 'medium' }
/** A price date (YYYY-MM-DD) is a calendar day: formatted in UTC so it never shifts. */
export const DATE_MEDIUM_UTC: Intl.DateTimeFormatOptions = { dateStyle: 'medium', timeZone: 'UTC' }
export const DAY_SUFFIX = 'T00:00:00Z'
export const REVIEW_OPT = { send: 'send', discard: 'discard', addAgain: 'add_again_as_new', retryFailed: 'retry_failed' } as const
export const REVIEW_BTN = 'px-2.5 py-1 rounded-md text-xs border border-white/10 hover:bg-white/10'
export const OUTBOX_STOP = { stale: 'stale', missing: 'missing', conflict: 'conflict' } as const
export const DECK_STOP = { conflict: 'conflict', missing: 'missing', failed: 'failed' } as const
export const DECK_ACT = { keepMine: 'keep_mine', discard: 'discard', tryAgain: 'try_again' } as const
